import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "state/lastBuySell/selectors";
import { setDefinition } from "state/lastBuySell/actions";
import Checkbox from "@ls/react-checkbox";
import styled from "styled-components";
import LastBuySellDefinition from "state/lastBuySell/LastBuySellDefinition";
const Item = styled.div`
  padding: 5px;
  margin: 0 0 5px 0;
  background: #bfbfbf;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  border: 1px solid #a2a2a2;
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  &:hover {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
`;
const LastBuySellSelector = () => {
  const definition = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  )?.[0];
  const dispatch = useDispatch();

  const [setLastBuy, setLastSell] = useMemo(() => {
    return [
      (value) =>
        dispatch(
          setDefinition(
            0,
            definition
              ? definition.setLastBuy(value)
              : new LastBuySellDefinition({ lastBuy: true })
          )
        ),
      (value) =>
        dispatch(
          setDefinition(
            0,
            definition
              ? definition.setLastSell(value)
              : new LastBuySellDefinition({ lastSell: true })
          )
        ),
    ];
  }, [definition, dispatch]);

  return (
    <>
      <Item>
        <Checkbox
          label={"Last Buy Transaction Date"}
          value={definition?.lastBuy ?? false}
          onChange={setLastBuy}
        />
      </Item>
      <Item>
        <Checkbox
          label={"Last Sell Transaction Date"}
          value={definition?.lastSell ?? false}
          onChange={setLastSell}
        />
      </Item>
    </>
  );
};

export default LastBuySellSelector;
